import { NAV_LINKS } from "../data/content";
import { scrollToId } from "../lib/scroll";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-[#04070F] border-t border-white/[0.06] pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/[0.06]">
        <div className="lg:col-span-6">
          <div className="flex items-center gap-5">
            <LogoMark className="w-16 h-16 shrink-0" testId="footer-logo-mark" />
            <div>
              <p className="font-serif text-4xl sm:text-5xl tracking-[0.12em] text-[#F8F9FA] leading-none" data-testid="footer-wordmark">
                CALLIOPE
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-teal-500 mt-3">
                Life Sciences Advisory
              </p>
            </div>
          </div>
          <p className="mt-6 text-sm text-slate-500 leading-relaxed max-w-md">
            Connecting expertise to advance science.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-5">Navigate</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="text-sm text-slate-400 hover:text-teal-300 transition-colors duration-300"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-5">Reach</p>
          <p className="text-sm text-slate-400 leading-relaxed">
            Edmonton, Alberta, Canada
            <br />
            Serving clients globally
          </p>
          <p className="text-sm text-teal-400 mt-3">info@calliopeadvisory.ca</p>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-xs text-slate-600" data-testid="footer-copyright">
          © 2026 Calliope Life Sciences Advisory. All rights reserved.
        </p>
        <p className="text-xs text-slate-600 max-w-xl" data-testid="footer-disclaimer">
          Career metrics presented on this site reflect Dr. Aspeslet's executive experience prior
          to the founding of Calliope.
        </p>
      </div>
    </div>
  </footer>
);
